import React from 'react'
import { Container, Row,Col } from "react-bootstrap";

function SearchPage() {
    return (
        
            <div class="header__box">
            <Row>
              <div class="col-10 m-auto">
                <div class="header__text">
                  <h1 class="header__title">
                    Биржа групп и каналов в социальных сетях
                  </h1>
                  <div class="header__subtitle">
                    Удобная продажа/покупка групп и каналов через безопасную
                    сделку
                  </div>
                </div>
              </div>
              </Row>
              </div>
             
       
    )
}

export default SearchPage
